import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type EntityRef, Status } from "@client/types";
import { type AppState } from "@client/types/AppState";
import { type AnyAction, type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type BlogDetailContent } from "./types";

export enum Actions {
  InitBegin = "MODULE_BLOG_DETAIL_CONTENT_INIT_BEGIN",
  InitFailure = "MODULE_BLOG_DETAIL_CONTENT_INIT_FAILURE",
  InitSuccess = "MODULE_BLOG_DETAIL_CONTENT_INIT_SUCCESS"
}

export type InitBeginActionData = EntityRef & {
  postId: string;
};
export type InitSuccessActionData = BlogDetailContent.Api.InitResponse;
export const _init = initAction<AppState, InitBeginActionData, BlogDetailContent.Api.InitResponse>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: AppState, dispatch: Dispatch<AnyAction>, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);

    return api.init(apiInfo, { postId: args.postId });
  },
  getShouldInit: (state: AppState, args: InitBeginActionData) => !!args.postId
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);

  if (localState.status === Status.None) {
    dispatch(_init({ ...args, postId: state.page.postId! }));
  }
};
